require('./index.less');
var tpl = require('./index.html');
var locale = require('../../i18n');

var manager = {
    init: function() {
        $('#event-management').html(tpl({
            locale: locale()
        }));
        this.$supportedList = $('.supported-event-list');
        this.__bindEvent();
    },
    __bindEvent: function() {
        var that = this;
        $('#event-management').on('click', function(e) {
            if (e.target.tagName === 'I' 
                && $(e.target).hasClass('ui-icon-minus')) {
                $(e.target).parent().parent().remove();
            }
        });

        $('#add-event-var').button({
            icons: {
                primary: 'ui-icon-plus'
            }
        }).on('click', function() {
            var name = $('#supported-event').val();
            var des = $('#supported-event-des').val();
            if (!/^\w+$/.test(name)) {
                $('#supported-event').effect('highlight');
                return;
            }
            var $li = that.$supportedList.find('li[name=' + name + ']');
            if ($li.size()) {
                $li.effect('highlight');
                $('#supported-event').effect('highlight');
                return;
            }
            $('<li class="ui-widget-content">')
                .attr('name', name)
                .append($('<span class="name">').text(name))
                .append($('<span class="des">').text(des))
                .append('<span class="ui-widget-content"><i class="ui-icon ui-icon-minus"></i></span>')
                .appendTo(that.$supportedList);

            $('#supported-event').val('');
            $('#supported-event-des').val('');
        });
    },
    getSupportedEventList: function() {
        return this.$supportedList
            .find('li')
            .map(function() {
                var $this = $(this);
                return {
                    id: $this.find('span.name').text(),
                    name: $this.find('span.name').text(),
                    des: $this.find('span.des').text()
                };
        }).get();
    },
    setSupportedEventList: function(list) {
        this.$supportedList.html('');
        list = list || [];
        for (var i = 0; i < list.length; i++) {
            $('<li class="ui-widget-content">')
                .attr('name', list[i].name)
                .append($('<span class="name">').text(list[i].name))
                .append($('<span class="des">').text(list[i].des))
                .append('<span class="ui-widget-content"><i class="ui-icon ui-icon-minus"></i></span>')
                .appendTo(this.$supportedList);
        }
    }
};
module.exports = manager;


/*****************
 ** WEBPACK FOOTER
 ** ./src/managers/event/index.js
 ** module id = 34
 ** module chunks = 0
 **/